import React from "react";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import EditIcon from "../../../../Icons/EditIcon";
import DuplicateIcon from "../../../../Icons/DuplicateIcon";
import PreviewIcon from "../../../../Icons/PreviewIcon";
import CancelIcon from "../../../../Icons/CancelIcon";
import ArchiveIcon from "../../../../Icons/ArchiveIcon";
import PublishIcon from "../../../../Icons/PublishIcon";
import ScheduleIcon from "../../../../Icons/ScheduleIcon";

export default ({ classes, data, ...rest }) => {
  const {
    onEditClickedCallback,
    onDuplicateClickedCallback,
    onCancelClickedCallback,
    onArchiveClickedCallback,
    onPreviewClickedCallback,
    onPublishClickedCallback,
  } = rest;

  return (
    <Box
      style={{
        marginTop: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: 46,
      }}
    >
      {/* Publish button */}
      {data.status === "publish_scheduled" && (
        <Box
          className={clsx(
            classes.singleEntryButtonWrapper,
            classes.multipleEntriesButtonWrapper
          )}
          onClick={() => onPublishClickedCallback(data, true)}
        >
          <PublishIcon viewBox="0 0 24 24" className={classes.publishIcon} />
          <Typography
            className={clsx(
              classes.buttonText,
              classes.multipleEntriesButtonText
            )}
            noWrap
          >
            Publish
          </Typography>
        </Box>
      )}

      {/* Schedule Invite button */}
      {data.status === "published" && (
        <Box
          className={clsx(
            classes.singleEntryButtonWrapper,
            classes.multipleEntriesButtonWrapper
          )}
          onClick={() => onPublishClickedCallback(data, false)}
        >
          <ScheduleIcon viewBox="0 0 24 24" className={classes.scheduleIcon} />
          <Typography
            className={clsx(
              classes.buttonText,
              classes.multipleEntriesButtonText
            )}
            noWrap
          >
            Schedule Invite
          </Typography>
        </Box>
      )}

      {/* Edit & Preview buttons */}
      {data.status !== "canceled" && (
        <>
          <Box
            className={clsx(
              classes.singleEntryButtonWrapper,
              classes.multipleEntriesButtonWrapper
            )}
            onClick={() => onEditClickedCallback(data)}
          >
            <EditIcon
              viewBox="0 0 16 16"
              className={classes.editIcon}
              style={{ height: 24 }}
            />
            <Typography
              className={clsx(
                classes.buttonText,
                classes.multipleEntriesButtonText
              )}
              noWrap
            >
              Edit
            </Typography>
          </Box>
          <Box
            className={clsx(
              classes.singleEntryButtonWrapper,
              classes.multipleEntriesButtonWrapper
            )}
            onClick={() => onPreviewClickedCallback(data)}
          >
            <PreviewIcon
              viewBox="0 0 18 12"
              className={classes.previewIcon}
              style={{ height: 24 }}
            />
            <Typography
              className={clsx(
                classes.buttonText,
                classes.multipleEntriesButtonText
              )}
              noWrap
            >
              Preview
            </Typography>
          </Box>
        </>
      )}

      {/* Duplicate button */}
      <Box
        className={clsx(
          classes.singleEntryButtonWrapper,
          classes.multipleEntriesButtonWrapper
        )}
        onClick={() => onDuplicateClickedCallback(data)}
      >
        <DuplicateIcon
          viewBox="0 0 15 17"
          className={classes.duplicateIcon}
          style={{ height: 24 }}
        />
        <Typography
          className={clsx(
            classes.buttonText,
            classes.multipleEntriesButtonText
          )}
          noWrap
        >
          Duplicate
        </Typography>
      </Box>

      {/* Cancel or Archive button */}
      {["published", "invited", "invite_scheduled"].includes(data.status) ? (
        <Box
          className={clsx(
            classes.singleEntryNegButtonWrapper,
            classes.multipleEntriesButtonWrapper
          )}
          onClick={() => onCancelClickedCallback(data)}
        >
          <CancelIcon
            viewBox="0 0 18 18"
            className={classes.cancelIcon}
            style={{ height: 24 }}
          />
          <Typography
            className={clsx(
              classes.buttonText,
              classes.multipleEntriesButtonText
            )}
            noWrap
          >
            Cancel Event
          </Typography>
        </Box>
      ) : (
        <Box
          className={clsx(
            classes.singleEntryButtonWrapper,
            classes.multipleEntriesButtonWrapper
          )}
          onClick={() => onArchiveClickedCallback(data)}
        >
          <ArchiveIcon
            viewBox="0 0 14 14"
            className={classes.archiveIcon}
            style={{ height: 24 }}
          />
          <Typography
            className={clsx(
              classes.buttonText,
              classes.multipleEntriesButtonText
            )}
            noWrap
          >
            Archive
          </Typography>
        </Box>
      )}
    </Box>
  );
};
